import React from 'react';
import { PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION } from 'pages/PurchaseRequisitionTypeOption/utils/constants';

const loadPage = (name) =>
  React.lazy(() => import('pages/PurchaseRequisitionTypeOption/Pages').then((module) => ({ default: module[name] })));

const PurchaseCategoryOption = loadPage('PurchaseCategoryOption');
const PurchaseCategoryOptionAdd = loadPage('PurchaseCategoryOptionAdd');
const PurchaseCategoryOptionEdit = loadPage('PurchaseCategoryOptionEdit');
const PurchaseCategoryOptionDetail = loadPage('PurchaseCategoryOptionDetail');

const ProductConditionTypeOption = loadPage('ProductConditionTypeOption');
const ProductConditionTypeOptionAdd = loadPage('ProductConditionTypeOptionAdd');
const ProductConditionTypeOptionEdit = loadPage('ProductConditionTypeOptionEdit');
const ProductConditionTypeOptionDetail = loadPage('ProductConditionTypeOptionDetail');

const PurchasePriorityOption = loadPage('PurchasePriorityOption');
const PurchasePriorityOptionAdd = loadPage('PurchasePriorityOptionAdd');
const PurchasePriorityOptionEdit = loadPage('PurchasePriorityOptionEdit');
const PurchasePriorityOptionDetail = loadPage('PurchasePriorityOptionDetail');

const routes = [
  {
    path: '/purchase-category-option',
    exact: true,
    name: 'Danh sách nhóm nghiệp vụ mua',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: PurchaseCategoryOption,
  },
  {
    path: '/purchase-category-option/add',
    exact: true,
    name: 'Thêm mới nhóm nghiệp vụ mua',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.ADD,
    component: PurchaseCategoryOptionAdd,
  },
  {
    path: '/purchase-category-option/edit/:id',
    exact: true,
    name: 'Chỉnh sửa nhóm nghiệp vụ mua',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.EDIT,
    component: PurchaseCategoryOptionEdit,
  },
  {
    path: '/purchase-category-option/detail/:id',
    exact: true,
    name: 'Chi tiết nhóm nghiệp vụ mua',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: PurchaseCategoryOptionDetail,
  },
  {
    path: '/product-condition-type-option',
    exact: true,
    name: 'Danh sách điều kiện hàng áp dụng',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: ProductConditionTypeOption,
  },
  {
    path: '/product-condition-type-option/add',
    exact: true,
    name: 'Thêm mới điều kiện hàng áp dụng',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.ADD,
    component: ProductConditionTypeOptionAdd,
  },
  {
    path: '/product-condition-type-option/edit/:id',
    exact: true,
    name: 'Chỉnh sửa điều kiện hàng áp dụng',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.EDIT,
    component: ProductConditionTypeOptionEdit,
  },
  {
    path: '/product-condition-type-option/detail/:id',
    exact: true,
    name: 'Chi tiết điều kiện hàng áp dụng',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: ProductConditionTypeOptionDetail,
  },
  {
    path: '/purchase-priority-option',
    exact: true,
    name: 'Danh sách mức ưu tiên mặc định',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: PurchasePriorityOption,
  },
  {
    path: '/purchase-priority-option/add',
    exact: true,
    name: 'Thêm mới mức ưu tiên mặc định',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.ADD,
    component: PurchasePriorityOptionAdd,
  },
  {
    path: '/purchase-priority-option/edit/:id',
    exact: true,
    name: 'Chỉnh sửa mức ưu tiên mặc định',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.EDIT,
    component: PurchasePriorityOptionEdit,
  },
  {
    path: '/purchase-priority-option/detail/:id',
    exact: true,
    name: 'Chi tiết mức ưu tiên mặc định',
    function: PURCHASE_REQUISITION_TYPE_OPTION_PERMISSION.VIEW,
    component: PurchasePriorityOptionDetail,
  },
];

export default routes;
